import { track } from '@bnnvara/analytics/src/track';

/**
 * When we send the mutation it takes some time before the new state is included in the database.
 * As a result, the query does not always return latest state if we would refresh the page shortly after sending the mutation.
 */
export const handleClick = async ({
  isBookmarked,
  toggleBookmark,
  mediaId,
  setIsBookmarked,
  setShowTooltip,
  userId,
}) => {
  const newValue = !isBookmarked;
  const result = await toggleBookmark({
    variables: {
      contentId: String(mediaId),
      contentType: 'media',
      userId,
      isBookmarked: newValue,
    },
  });

  if (result.data.bookmark.error || result.error) {
    return;
  }

  if (result.data.bookmark.isBookmarked === true) {
    setIsBookmarked(true);
    track(
      'video-player-bookmark',
      'click',
      `video ${mediaId} saved on profile`
    );
    setShowTooltip(true);
    return;
  }

  if (result.data.bookmark.isBookmarked === false) {
    setIsBookmarked(false);
    track(
      'video-player-bookmark',
      'click',
      `video ${mediaId} deleted from profile`
    );
    setShowTooltip(true);
  }
};
